import messages from '../../messages-archive-promo.json'
import { getPlayerId } from '../controllers/stats'
import getLocalDate from './getLocalDate'
import random from 'random-seed'

const INITIAL_MESSAGES = { title: '', subText: '', completionMessage: '' }

export function generateArchivePromoMessage(
	percentage: number,
	available: number
): {
	title: string
	subText: string
	completionMessage: string
} {
	const rng = random(getPlayerId() + getLocalDate())
	const randFromArr = arr => arr[rng(arr.length)]

	//Find the highest value below or equal to percentage
	const bound = Object.keys(messages)
		.reverse()
		.find(k => Number(k) <= percentage)

	if (bound === undefined) return INITIAL_MESSAGES

	const selectedBound = messages[bound]

	const title = randFromArr(Object.keys(selectedBound.title))
	const subText = selectedBound.title[title].replaceAll('#', available)
	const completionMessage = randFromArr(selectedBound.message)

	return { title: title, subText: subText, completionMessage: completionMessage }
}
